var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeAttachmentSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HomeAttachment_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,3.54a5.87,5.87,0,0,0-2-1.19A6,6,0,0,0,17,2a6,6,0,0,0-6,6V22a4,4,0,0,0,2,3.44,3.85,3.85,0,0,0,4,0A4,4,0,0,0,19,22V10a1,1,0,0,0-2,0V22a2,2,0,0,1-4,0V8a4,4,0,0,1,4-4,3.91,3.91,0,0,1,2,.56A4,4,0,0,1,21,8V22a6,6,0,0,1-2,4.46,5.87,5.87,0,0,1-2,1.19,5.89,5.89,0,0,1-4,0,5.87,5.87,0,0,1-2-1.19A6,6,0,0,1,9,22V10a1,1,0,0,0-2,0V22a8,8,0,0,0,2,5.27,7.94,7.94,0,0,0,4,2.47,8,8,0,0,0,6-.82,8.16,8.16,0,0,0,2-1.65A8,8,0,0,0,23,22V8A6,6,0,0,0,21,3.54Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAttachmentSvg);
export default __webpack_public_path__ + "static/media/HomeAttachment_svg.ab392f6b27a5a5c4b059affe98ce5510.svg";
export { ForwardRef as ReactComponent };